import React, { Suspense, lazy } from 'react';
import { Box, CircularProgress, Popover } from '@mui/material';

// The full picker is ~65 KB gzip, so it only downloads the first time someone
// actually opens it — the chat widget itself stays light.
const EmojiPicker = lazy(() => import('emoji-picker-react'));

interface Props {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onPick: (emoji: string) => void;
}

const EmojiPickerPopover: React.FC<Props> = ({ anchorEl, onClose, onPick }) => (
  <Popover
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
    transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    // Keep the composer focused so typing can continue around the picker.
    disableAutoFocus
    disableEnforceFocus
    slotProps={{ paper: { sx: { borderRadius: 2, overflow: 'hidden' } } }}
  >
    <Suspense
      fallback={
        <Box sx={{ width: 300, height: 380, display: 'grid', placeItems: 'center' }}>
          <CircularProgress size={22} />
        </Box>
      }
    >
      <EmojiPicker
        onEmojiClick={(data: any) => onPick(data.emoji)}
        width={300}
        height={380}
        searchPlaceholder="Search emoji"
        previewConfig={{ showPreview: false }}
        skinTonesDisabled
      />
    </Suspense>
  </Popover>
);

export default EmojiPickerPopover;
